import React from 'react'
import ReactTooltip from 'react-tooltip'
import styles from './styles.module.scss'

interface Props {
  model: any
  day: any
  getDayData: any
}

const DayModel: React.FC<Props> = ({ model, day, getDayData }) => {
  const { opacity: colorOpacity, amount } = getDayData(day.dayToAmount, day.dayOfWeek, model.time)
  // eslint-disable-next-line max-len
  const backgroundColor = `rgba(var(--color-analytics-r), var(--color-analytics-g), var(--color-analytics-b), ${colorOpacity / 100})`

  return (
    <div
      key={model.time}
      data-tip
      data-for={`${day.dayOfWeek}-tooltip-${model.time}`}
      style={{ backgroundColor }}
      className={styles.gridItem}>
      <ReactTooltip
        className={styles.tooltip}
        place="top"
        type="light"
        effect="solid"
        id={`${day.dayOfWeek}-tooltip-${model.time}`}>
        <span>{amount}</span>
      </ReactTooltip>
    </div>
  )
}

export default DayModel
